import faker from 'faker'
import moment from 'moment'

export const mocker = {
  columnsLabels () {
    let labels = {
      'REQUSETALL': {
        '0': 'อนุมัติรวม',
        '10': 'ชื่อเรื่อง',
        '20': 'วันที่ขอ',
        '30': 'สถานะ',
        '40': 'รายละเอียด'
      }
    }
    let mockLabels = {
      en: labels,
      th: labels
    }
    let mockIndexColumns = [{
      key: 'codapp',
      name: labels['REQUSETALL']['10'],
      style: 'min-width: 150px;'
    }, {
      key: 'dtereq',
      name: labels['REQUSETALL']['20'],
      class: 'align-center',
      style: 'min-width: 120px;'
    }, {
      key: 'status',
      name: labels['REQUSETALL']['30'],
      style: 'min-width: 200px;'
    }, {
      key: 'description',
      name: labels['REQUSETALL']['40'],
      style: 'min-width: 200px;'
    }]

    return {
      columns: {
        en: {
          index: mockIndexColumns
        },
        th: {
          index: mockIndexColumns
        }
      },
      labels: mockLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 50
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codapp: faker.lorem.words(),
        dtereq: moment().format('DD/MM/YYYY'),
        status: mockStatus[staappr],
        description: faker.lorem.words()
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  dropdowns () {
    const mockStaappr = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockCodapp = {
      'ALL': 'All',
      'HRES32E': 'HRES32E - บันทึกแจ้งการเปลี่ยนแปลงข้อมูลพนง.',
      'HRES34E': 'HRES34E - บันทึกการขอโอนย้าย',
      'HRES36E': 'HRES36E - บันทึกการขอหนังสือรับรอง',
      'HRES3BE': 'HRES3BE - บันทึกคำร้องเรียนของพนง.',
      'HRES62E': 'HRES62E - บันทึกใบลา',
      'HRES6AE': 'HRES6AE - บันทึกคำร้องแก้ไขเวลาเข้า-ออก',
      'HRES6DE': 'HRES6DE - บันทึกคำร้องแก้ไขเวลาทำงาน',
      'HRES6IE': 'HRES6IE - บันทึกคำร้องขอฝึกอบรม',
      'HRES6KE': 'HRES6KE - บันทึกคำร้องขอทำงานล่วงเวลา',
      'HRES6ME': 'HRES6ME - บันทึกขอยกเลิกการลา',
      'HRES71E': 'HRES71E - บันทึกคำร้องขอเบิกค่ารักษาพยาบาล',
      'HRES74E': 'HRES74E - บันทึกคำร้องขอเบิกสวัสดิการ',
      'HRES77E': 'HRES77E - บันทึกคำร้องขอเบิกเงินกู้',
      'HRES7DE': 'HRES7DE - บันทึกสรุปผลการเข้าอบรม',
      'HRES81E': 'HRES81E - บันทึกคำร้องขอค่าเดินทาง',
      'HRES82E': 'HRES82E - บันทึกคำร้องจองห้องประชุม',
      'HRES83E': 'HRES83E - บันทึกการจองทรัพย์สิน',
      'HRES86E': 'HRES86E - บันทึกคำร้องขอลาออก',
      'HRES88E': 'HRES88E - บันทึกคำร้องขออนุมัติจ้างงาน',
      'HRES91E': 'HRES91E - บันทึกคำร้องขอยกเลิกการฝึกอบรม',
      'HRES93E': 'HRES93E - บันทึกขอยกเลิกการอบรมของหลักสูตร',
      'HRES95E': 'HRES95E - บันทึกการขอแลกกะ',
      'HRESS2E': 'HRESS2E - บันทึกคำร้องแก้ไขอัตราเงินสะสมกองทุน',
      'HRESS4E': 'HRESS4E - บันทึกการสมัครภายใน'
    }
    return {
      p_staappr: {
        en: mockStaappr,
        th: mockStaappr
      },
      p_codapp: {
        en: mockCodapp,
        th: mockCodapp
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/requestall/mocker.js